module.exports = __webpack_public_path__ + "assets/img/more-btn-5e1d29ef.png";